import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { getIncidentById, put_Incident } from '../../../services/Tickets';
import useAuth from '../../../hook/useAuth';
import { getTicketStatusesByAttribute } from '../../../services/TicketStatus';
import { FaCloudUploadAlt } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { post_Comment, getThreadedComments } from '../../../services/Comment';
import useDelete from '../../../hook/useDelete';
import { appName, ticketBaseURL } from '../../../config/api';
import useAttachments from '../../../hook/useAttachments';
import { format } from 'date-fns';
import { upload_CommonFileSupportTicket } from '../../../services/commonFileUpload';
import { delete_fileUpload, getFileUploads, post_fileUpload } from '../../../services/FileUpload';
import Cookies from 'js-cookie';

const EditSupportTicket = () => {
    const navigate = useNavigate();
    const { auth }: any = useAuth();
    const tenantId = Cookies.get("tenantId-my-cdir") || "";
    const { id }: any = useParams();
    const { setViewImages, setAttachments, setCurrentIndex }: any = useAttachments();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const [supportTicketData, setSupportTicketData] = useState<any>({
        accountId: 0,
        incidentName: "",
        status: "2",
        requester: "",
        description: "",
        categoryId: 0,
        subcategoryId: 0,
        assignedToUserId: 0,
        assignedToGroupAssignmentId: 0,
        priority: "",
        dueDate: "",
        emailCC: "",
        expectedRevenue: 0,
        groupId: "0",
        appGroupId: "0",
        appName: appName,
        createdAt: "",
        createdBy: "",
        updatedAt: "",
        updatedBy: ""
    });
    const [priorityData, setPriorityData] = useState<any[]>([]);
    const [isProcessing, setIsProcessing] = useState<boolean>(false);
    const [isChanges, setIsChanges] = useState<boolean>(true);
    const [comments, setComments] = useState<any[]>([]);
    const [newComment, setNewComment] = useState<string>('');
    const [replyingTo, setReplyingTo] = useState<number | null>(null);
    const [replyPostingId, setReplyPostingId] = useState<number | null>(null);
    const [replyText, setReplyText] = useState<string>("");
    const [isLoadingComments, setIsLoadingComments] = useState(false);
    const [isPostingComment, setIsPostingComment] = useState(false);
    const [isDataUploading, setIsDataUploading] = useState<boolean>(false);
    const [isLoadingAttachments, setIsLoadingAttachments] = useState(false);
    const [attachmentsValue, setAttachmentsValue] = useState<any[]>([]);
    const [key, setKey] = useState<number>(0);

    const fileRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        getTicketStatusesByAttribute('Priority')
            .then((res) => {
                setPriorityData(res?.reverse().map((item: any) => ({
                    value: item?.id,
                    label: item?.status
                })));
            })
    }, [])

    useEffect(() => {
        getIncidentById(id)
            .then(res => {
                setSupportTicketData({
                    ...res,
                    status: res.status !== "" && res.status !== "string" ? res.status : "0",
                    priority: res.priority !== "string" && res.priority !== "" ? res.priority : "0",
                    dueDate: res.dueDate?.split("T")[0]
                });
            })
            .catch((error) => {
                console.log(error)
            })
    }, [id]);

    useEffect(() => {
        if (!id || !isChanges) return;

        setIsLoadingComments(true);

        getThreadedComments("Incidents", id)
            .then((res) => {
                setComments(res.reverse());
                setIsChanges(false);
            })
            .catch((error) => console.log(error))
            .finally(() => setIsLoadingComments(false));
    }, [id, isChanges]);

    useEffect(() => {
        if (id && !isDataUploading) {
            setIsLoadingAttachments(true);

            getFileUploads("Incidents", id)
                .then((res) => {
                    setAttachmentsValue(res);
                })
                .catch((error) => console.log(error))
                .finally(() => setIsLoadingAttachments(false));
        }
    }, [id, isDataUploading]);

    const getFileExtension = (fileName: string) => {
        return fileName?.split('.').pop()?.toLowerCase() || "";
    }

    const isImageFile = (fileName: string) => {
        const extension = getFileExtension(fileName);
        return ["jpg", "jpeg", "png", "heif", "heic"].includes(extension);
    }

    const isPdfFile = (fileName: string) => {
        return getFileExtension(fileName) === "pdf";
    }

    const isCsvFile = (fileName: string) => {
        return getFileExtension(fileName) === "csv";
    }

    const getFileUrl = (fileName: string) => {
        return `${ticketBaseURL}commonFile/Get?name=${encodeURIComponent(fileName)}`;
    }

    const onFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!isDataUploading) {
            const selectedFiles = e.target.files as FileList;

            if (selectedFiles.length !== 0) {
                saveImageFile(selectedFiles[0]);
                if (fileRef.current) {
                    fileRef.current.value = '';
                    setKey((prevKey) => prevKey + 1);
                }
            }
        }
    };

    const saveImageFile = (imageFile: File) => {
        setIsDataUploading(true);
        const formData = new FormData();
        formData.append("ImageFile", imageFile);

        upload_CommonFileSupportTicket(formData)
            .then(res => {
                post_fileUpload({
                    attributeName: "Incidents",
                    attributeId: id,
                    fileName: res,
                    tabName: "Incidents",
                    userId: auth?.id,
                    createdDate: new Date()
                })
                    .then(() => {
                        setIsDataUploading(false);
                    })
                    .catch(error => console.error(error))
            })
            .catch(error => console.error(error))
    }

    const viewImage = (index: number) => {
        setViewImages(true);
        setAttachments(attachmentsValue)
        setCurrentIndex(index);
    }

    const deleteImage = (id: number) => {
        setDeleteData({
            id: id,
            tilte: `Delete`,
            summary: `Are you sure you want to delete this Attachment?`,
            isDelete: (callback: any) => {
                setIsDataUploading(true);

                delete_fileUpload(id?.toString())
                    .then(() => {
                        setAttachmentsValue(() => attachmentsValue?.filter((item: any) => item?.id !== id));
                    })
                    .catch(error => console.error(error))
                    .finally(() => {
                        callback && callback();
                        setIsDataUploading(false);
                    });
            }
        });

        setDeletePopup(true);
    }

    const reloadComments = () => {
        setIsLoadingComments(true);

        getThreadedComments("Incidents", id)
            .then((res) => setComments(res.reverse()))
            .catch((err) => console.error(err))
            .finally(() => setIsLoadingComments(false));
    };

    const handleAddComment = async () => {
        if (!newComment.trim()) return;

        try {
            setIsPostingComment(true);

            await post_Comment({
                attributeName: "Incidents",
                attributeId: id,
                notes: newComment,
                userId: auth?.id,
                createdBy: auth?.givenname,
                createdDate: new Date().toISOString(),
                groupId: "",
                parentCommentId: ""
            });

            setNewComment("");
            reloadComments();
        } catch (err) {
            console.error(err);
        } finally {
            setIsPostingComment(false);
        }
    };

    const handleReply = async (parentId: number) => {
        if (!replyText.trim()) return;

        try {
            setReplyPostingId(parentId);

            await post_Comment({
                attributeName: "Incidents",
                attributeId: id,
                notes: replyText,
                userId: auth?.id,
                createdBy: auth?.givenname,
                createdDate: new Date().toISOString(),
                groupId: "",
                parentCommentId: parentId,
            });

            setReplyText("");
            setReplyingTo(null);
            setIsChanges(true);
        } catch (err) {
            console.error(err);
        } finally {
            setReplyPostingId(null);
        }
    };

    const renderComments = (list: any[], level = 0) => {
        return list.map((c: any) => (
            <div
                key={c.id}
                className={`${level > 0 ? "ml-10 border-l-2 border-gray-200 pl-4" : ""} mt-3`}
            >
                <div className="bg-gray-50 border rounded-xl p-3">
                    <div className="flex items-center justify-between">
                        <p className={`text-sm text-secondary font-semibold`}>
                            {c.createdBy || "Unknown User"}
                        </p>

                        <p className="text-xs text-gray-400">
                            {c?.createdDate ? format(new Date(c.createdDate), "MM/dd/yyyy hh:mm aaaa") : ""}
                        </p>
                    </div>

                    <p className={`text-sm text-black mt-1 whitespace-pre-wrap`}>
                        {c.notes}
                    </p>

                    {!isStatusNew && (
                        <div className="flex gap-4 mt-2 text-xs text-gray-500">
                            <button
                                type="button"
                                onClick={() => setReplyingTo(c.id)}
                                disabled={replyPostingId === c.id}
                                className={`text-secondary font-medium text-sm
                                 hover:text-custom-blue
                                 hover:underline underline-offset-4
                                 transition-all duration-200
                                 ${replyPostingId === c.id ? "opacity-50 cursor-not-allowed" : ""}`}
                            >
                                Reply
                            </button>
                        </div>
                    )}

                    {replyingTo === c.id && (
                        <div className="mt-3 flex gap-2 items-start">
                            <textarea
                                className="w-full border rounded p-2 text-sm text-black outline-secondary"
                                placeholder={`Reply...`}
                                value={replyText}
                                onChange={(e) => setReplyText(e.target.value)}
                            />

                            <button
                                type="button"
                                disabled={replyPostingId === c.id}
                                onClick={() => handleReply(c.id)}
                                className={`px-3 py-2 rounded text-sm text-white self-start
                                 shadow-sm hover:shadow-md active:shadow-sm
                                 transition-all duration-200
                                  ${replyPostingId === c.id ? "bg-[#4d6a8f] cursor-not-allowed" : "bg-secondary"} hover:bg-custom-blue`}
                            >
                                {replyPostingId === c.id ? "Posting..." : "SEND"}
                            </button>
                        </div>
                    )}
                </div>

                {c.replies && c.replies.length > 0 && (
                    <div className="mt-3 space-y-3">
                        {renderComments(c.replies, level + 1)}
                    </div>
                )}
            </div>
        ));
    };

    const closeModal = () => navigate(-1);

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (!isProcessing) {
            setIsProcessing(true);

            put_Incident({
                ...supportTicketData,
                priority: supportTicketData.priority,
                createdAt: new Date().toISOString(),
                createdBy: auth?.givenname,
                updatedAt: new Date().toISOString(),
                updatedBy: auth?.givenname,
                tenantId: tenantId
            }, auth?.id)
                .then(() => {
                    setIsProcessing(false);
                    navigate(-1);
                })
                .catch(error => {
                    setIsProcessing(false);
                    console.error(error);
                });
        }
    }

    const isStatusNew = supportTicketData.status === 'Closed';

    return (
        <div className="w-full">
            <div className="my-2">
                <div className="py-8 px-6 relative bg-white">
                    <h2 className="text-xl text-secondary font-bold">Edit Support Ticket</h2>
                    <form onSubmit={handleSubmit} className="mt-8 grid xm:grid-cols-2 gap-6 text-secondary">
                        <div>
                            <label className="font-semibold text-sm">Subject</label>
                            <input type='text' placeholder='Enter Subject'
                                className="w-full rounded py-2.5 px-4 mt-2 border-2 text-sm text-black outline-secondary"
                                value={supportTicketData.incidentName}
                                onChange={(e) => setSupportTicketData({ ...supportTicketData, incidentName: e.target.value })}
                                required
                            />
                        </div>

                        <div>
                            <label className="font-semibold text-sm">Priority</label>
                            <select
                                className="w-full rounded py-2.5 px-4 mt-2 border-2 text-sm text-black outline-secondary"
                                value={supportTicketData.priority}
                                onChange={(e) => {
                                    setSupportTicketData({ ...supportTicketData, priority: e.target.value })
                                }}
                            >
                                {
                                    priorityData.map((item: any, ind: number) => {
                                        return (
                                            <option key={ind} value={item.value}>{item.label}</option>
                                        )
                                    })
                                }
                            </select>
                        </div>

                        <div>
                            <label className="font-semibold text-sm">Description</label>
                            <textarea placeholder='Description'
                                className="w-full rounded py-2.5 px-4 border-2 mt-2 text-sm text-black outline-secondary"
                                value={supportTicketData.description}
                                onChange={(e) => setSupportTicketData({ ...supportTicketData, description: e.target.value })}
                            />
                        </div>

                        <div />

                        <div>
                            <span className="text-sm text-secondaryVariant font-semibold">{"Attachment"}</span>
                            <button
                                key={key}
                                type="button"
                                onClick={() => fileRef.current?.click()}
                                className="flex items-center gap-2 px-3 py-1.5 mt-2 rounded text-tertiary text-sm font-semibold border border-tertiary outline-none bg-white hover:opacity-80">
                                {isDataUploading ?
                                    <>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18px" className="mr-2 fill-tertiary inline animate-spin"
                                            viewBox="0 0 26.349 26.35">
                                            <circle cx="13.792" cy="3.082" r="3.082" data-original="#000000" />
                                            <circle cx="13.792" cy="24.501" r="1.849" data-original="#000000" />
                                            <circle cx="6.219" cy="6.218" r="2.774" data-original="#000000" />
                                            <circle cx="21.365" cy="21.363" r="1.541" data-original="#000000" />
                                            <circle cx="3.082" cy="13.792" r="2.465" data-original="#000000" />
                                            <circle cx="24.501" cy="13.791" r="1.232" data-original="#000000" />
                                            <path
                                                d="M4.694 19.84a2.155 2.155 0 0 0 0 3.05 2.155 2.155 0 0 0 3.05 0 2.155 2.155 0 0 0 0-3.05 2.146 2.146 0 0 0-3.05 0z"
                                                data-original="#000000" />
                                            <circle cx="21.364" cy="6.218" r=".924" data-original="#000000" />
                                        </svg>
                                        Processing...
                                    </>
                                    :
                                    <>
                                        <FaCloudUploadAlt />
                                        Add Attachment
                                    </>
                                }
                            </button>

                            <input
                                ref={fileRef}
                                type="file"
                                accept=".jpg,.jpeg,.png,.pdf,.csv,.heif,.heic"
                                name="file-choose"
                                className="hidden"
                                onChange={onFileChangeCapture}
                            />
                        </div>

                        <div />

                        {isLoadingAttachments && (
                            <div className="flex items-center justify-center py-6 text-gray-600 text-sm">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    className="mr-2 animate-spin"
                                >
                                    <circle cx="12" cy="12" r="10" strokeOpacity=".25" />
                                    <path d="M4 12a8 8 0 0 1 8-8" />
                                </svg>
                                Loading attachments...
                            </div>
                        )}

                        {!isLoadingAttachments && attachmentsValue?.length === 0 && (
                            <p className="text-sm text-gray-500">No attachments.</p>
                        )}

                        {!isLoadingAttachments && attachmentsValue?.length !== 0 && (
                            <div className="flex flex-wrap gap-4 col-span-2">
                                {attachmentsValue.map((attachment: any, index: number) => {
                                    const fileName = attachment?.fileName;
                                    const fileUrl = getFileUrl(fileName);

                                    const imageFile = isImageFile(fileName);
                                    const pdfFile = isPdfFile(fileName);
                                    const csvFile = isCsvFile(fileName);

                                    return (
                                        <div
                                            key={index}
                                            className="relative group w-40"
                                        >
                                            {/* Delete */}
                                            <div
                                                className="absolute z-10 top-1 right-1 bg-slate-200 rounded cursor-pointer invisible group-hover:visible"
                                                onClick={() => deleteImage(attachment?.id)}
                                            >
                                                <MdDelete size={24} />
                                            </div>

                                            {/* Attachment */}
                                            <div
                                                className="w-40 h-40 rounded cursor-pointer overflow-hidden border bg-gray-50"
                                                onClick={() => {
                                                    const extension = attachment?.fileName
                                                        ?.split(".")
                                                        .pop()
                                                        ?.toLowerCase();

                                                    const isImage = ["jpg", "jpeg", "png", "heif", "heic"].includes(extension);

                                                    if (isImage) {
                                                        viewImage(index);
                                                    } else {
                                                        setViewImages(true);
                                                        setAttachments(attachmentsValue);
                                                        setCurrentIndex(index);
                                                    }
                                                }}

                                            >
                                                {/* IMAGE */}
                                                {imageFile && (
                                                    <img
                                                        className="w-full h-24 object-cover"
                                                        src={fileUrl}
                                                        alt={fileName}
                                                    />
                                                )}

                                                {/* PDF */}
                                                {pdfFile && (
                                                    <div className="w-full h-24 flex flex-col justify-center items-center bg-red-50">
                                                        <span className="text-4xl">📄</span>
                                                        <span className="text-xs font-bold text-red-600">
                                                            PDF
                                                        </span>
                                                    </div>
                                                )}

                                                {/* CSV */}
                                                {csvFile && (
                                                    <div className="w-full h-24 flex flex-col justify-center items-center bg-green-50">
                                                        <span className="text-4xl">📊</span>
                                                        <span className="text-xs font-bold text-green-600">
                                                            CSV
                                                        </span>
                                                    </div>
                                                )}

                                                {/* Unknown */}
                                                {!imageFile && !pdfFile && !csvFile && (
                                                    <div className="w-full h-24 flex flex-col justify-center items-center bg-gray-100">
                                                        <span className="text-4xl">📎</span>
                                                        <span className="text-xs font-bold text-gray-600">
                                                            FILE
                                                        </span>
                                                    </div>
                                                )}

                                                {/* File information */}
                                                <div className="bg-primaryVariant w-full h-16 text-xs flex flex-col justify-center items-center px-1 py-1.5">
                                                    <span
                                                        className="font-semibold truncate w-full text-center"
                                                        title={fileName}
                                                    >
                                                        {fileName}
                                                    </span>

                                                    <span>
                                                        {format(
                                                            new Date(attachment?.createdDate),
                                                            "dd MMM yyyy, KK:mm a"
                                                        )}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}

                        <div className="mt-4 xm:col-span-2">
                            <div className="flex items-center justify-between mb-3">
                                <p className={`font-semibold text-sm text-secondary`}>Comments</p>
                            </div>

                            <div className="flex gap-2">
                                <textarea
                                    className="w-full border rounded p-2 text-sm text-black outline-secondary"
                                    placeholder="Write a comment..."
                                    value={newComment}
                                    onChange={(e) => setNewComment(e.target.value)}
                                />

                                <button
                                    type="button"
                                    onClick={handleAddComment}
                                    disabled={isPostingComment}
                                    className={`px-3 py-2 rounded text-sm text-white self-start
                                                         shadow-sm hover:shadow-md active:shadow-sm
                                                         transition-all duration-200
                                                         ${isPostingComment ? "bg-[#4d6a8f] cursor-not-allowed" : "bg-secondary"} hover:bg-custom-blue`}
                                >
                                    {isPostingComment ? (
                                        <>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                className="inline mr-2 animate-spin"
                                            >
                                                <circle cx="12" cy="12" r="10" strokeOpacity=".25" />
                                                <path d="M4 12a8 8 0 0 1 8-8" />
                                            </svg>
                                            Posting...
                                        </>
                                    ) : (
                                        "POST"
                                    )}
                                </button>
                            </div>

                            <div
                                className={`mt-4 overflow-y-auto space-y-4 pr-2 border rounded-lg p-3 bg-white
                                                ${(isLoadingComments || comments.length > 0) ? "h-[55vh]" : "min-h-[80px]"}`}
                            >
                                {isLoadingComments ? (
                                    <div className="flex items-center justify-center py-6 text-gray-600 text-sm">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="18"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            className="mr-2 animate-spin"
                                        >
                                            <circle cx="12" cy="12" r="10" strokeOpacity=".25" />
                                            <path d="M4 12a8 8 0 0 1 8-8" />
                                        </svg>
                                        Loading comments...
                                    </div>
                                ) : comments.length === 0 ? (
                                    <p className="text-sm text-gray-500">No comments yet.</p>
                                ) : (
                                    renderComments(comments)
                                )}
                            </div>
                        </div>

                        <div className="flex max-xm:flex-col gap-4 !mt-4">
                            <button
                                type="button"
                                className="px-6 py-2 min-w-[150px] rounded text-black text-sm font-semibold border-none outline-none bg-gray-200 hover:bg-gray-300 active:bg-gray-200"
                                onClick={closeModal}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="px-6 py-2 min-w-[150px] rounded text-white text-sm font-semibold border-none outline-none bg-secondary hover:bg-custom-blue"
                                disabled={isProcessing}
                            >
                                {isProcessing ? "Processing..." : "Save"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default EditSupportTicket;